var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntersection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3734",
    "data-name": "Group 3734",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3542",
    "data-name": "Rectangle 3542",
    width: 20,
    height: 20,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3733",
    "data-name": "Group 3733",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M19.741,10.515a7.546,7.546,0,0,0-1.953-3.384l-.166-.166h-.006a7.51,7.51,0,0,0-2.893-1.693A7.535,7.535,0,1,0,1.01,11.3a7.481,7.481,0,0,0,4.265,3.426,7.535,7.535,0,0,0,14.466-4.21M6.2,13.793a6.414,6.414,0,0,1-.007-2.635L8.832,13.8A6.414,6.414,0,0,1,6.2,13.793m3.854-.375L6.572,9.939a6.353,6.353,0,0,1,.457-.875l3.9,3.9a6.374,6.374,0,0,1-.876.456m1.787-1.146L7.72,8.153A6.414,6.414,0,0,1,8.4,7.505l4.082,4.083a6.358,6.358,0,0,1-.647.684m1.294-1.639L9.358,6.859a6.453,6.453,0,0,1,.915-.418l3.277,3.278a6.476,6.476,0,0,1-.419.915M13.8,6.195a6.377,6.377,0,0,1,.078,2.245L11.552,6.119a6.356,6.356,0,0,1,2.243.076m-11.8,4.539A6.4,6.4,0,1,1,13.409,4.981a7.536,7.536,0,0,0-8.425,8.43,6.356,6.356,0,0,1-2.994-2.677m16.016,4.933a6.4,6.4,0,0,1-11.421-.661,7.54,7.54,0,0,0,8.424-8.422,6.376,6.376,0,0,1,1.977,1.347l.064.064a6.405,6.405,0,0,1,.956,7.672",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersection);
export default __webpack_public_path__ + "static/media/intersection.099d13a3cfc94d5cc76f17f32368cf78.svg";
export { ForwardRef as ReactComponent };